import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import "aos/dist/aos.css"; 
import AOS from "aos";

const images = [
  {
    src: "https://static.vecteezy.com/system/resources/previews/042/977/797/non_2x/portrait-of-young-business-woman-happy-smiling-and-standing-posing-arms-crossed-free-png.png",
    alt: "People working with sticky notes on a glass wall",
  },
  {
    src: "https://static.vecteezy.com/system/resources/previews/024/344/087/non_2x/business-woman-isolated-illustration-ai-generative-free-png.png",
    alt: "People having a meeting in a glass room with green walls",
  },
  {
    src: "https://static.vecteezy.com/system/resources/previews/050/594/698/large_2x/an-attractive-young-businesswoman-auditor-writing-on-clipboard-smiling-and-confident-front-view-isolate-on-transparency-background-png.png",
    alt: "Three people working together on a computer",
  },
  {
    src: "https://static.vecteezy.com/system/resources/previews/050/594/698/large_2x/an-attractive-young-businesswoman-auditor-writing-on-clipboard-smiling-and-confident-front-view-isolate-on-transparency-background-png.png",
    alt: "Office space with colorful ceiling and skateboard wall art",
  },
];

export default function About() {
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <div className="container mx-auto mt-20 mb-4 p-4">
      <div className="text-center mb-10">
        <h1 className="text-5xl font-bold text-black">Fueling Minds</h1>
        <h2 className="text-4xl font-light text-gray-500 mt-2">— Inspiring Designs..</h2>
      </div>

      <div className="flex flex-col items-center mb-10">
        <img
          src="https://cdn.prod.website-files.com/643f7373d3f6653157617339/6576c7a25f51682c8ffa29e1_musemind-team.webp"
          alt="Group of people collaborating in a modern workspace"
          className="w-full rounded-lg shadow-lg"
        />
      </div>

      <section className="flex flex-col items-center justify-center bg-gray-100 p-10 rounded-lg shadow-lg mb-10">
        <div className="text-center max-w-2xl">
          <h1 className="text-5xl font-bold mb-4">Musemind Design Agency</h1>
          <h2 className="text-4xl font-bold mb-4">Igniting Excellence Through</h2>
          <h2 className="text-4xl font-bold mb-8">Dedication & Innovation</h2>
          <p className="text-gray-400 mb-4">
            At Musemind, our journey is fired by passion—our core spark. The secret to our innovation and success? It's the fusion of relentless dedication, a heart that beats for design, and a drive to innovate!
          </p>
          <p className="text-green-400 mb-8">
            In our design agency, we treasure integrity and transparency. Our commitment to ethical practices has been a driving force. Clients rely on us for clear communication, honest collaboration, and reliable results.
          </p>
          <button className="bg-yellow-400 text-black font-bold py-2 px-4 rounded-full hover:bg-yellow-300 transition duration-200">
            Discover our works
          </button>
        </div>
      </section>

      <div className="relative w-full max-w-4xl mx-auto mb-10 flex justify-center">
        <img
          src={images[currentIndex].src}
          alt={images[currentIndex].alt}
          className="custom-sizes object-cover rounded-lg shadow-lg transition-transform duration-700 max-h-[80vh] max-w-full"
        />
        
        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-3 rounded-full hover:bg-opacity-75 focus:outline-none"
        >
          &#10094;
        </button>

        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-3 rounded-full hover:bg-opacity-75 focus:outline-none"
        >
          &#10095;
        </button>

        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
          {images.map((_, index) => (
            <div
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-3 h-3 rounded-full cursor-pointer transition-colors duration-300 ${currentIndex === index ? "bg-black" : "bg-gray-400"}`}
            ></div>
          ))}
        </div>
      </div>

      <div className="flex flex-col items-center justify-center min-h-screen bg-white p-8">
        <h1 className="text-6xl font-bold text-black" data-aos="fade-right">Empowering</h1>
        <h2 className="text-6xl font-bold text-gray-500" data-aos="fade-left">Success Stories.</h2>
        <div className="flex flex-col md:flex-row items-center mt-10">
          <video
            src="https://cdn-icons-mp4.flaticon.com/512/17556/17556494.mp4"
            alt="3D abstract shape with rings"
            className="w-full md:w-1/2 rounded-lg shadow-lg hover:cursor-pointer"
            autoPlay
            loop
            muted
            data-aos="fade-right"
          />
          <div className="mt-10 md:mt-0 md:ml-10 text-gray-700" data-aos="zoom-in">
            <p className="mb-4">
              Over the years, we've propelled numerous businesses to thrive, maintaining robust partnerships through our collaborative approach.
            </p>
            <p className="mb-4">
              We are proud to help businesses grow and succeed in different industries. From startups to established enterprises, our tailored solutions have helped them conquer challenges, reach milestones, and actualize their visions.
            </p>
            <div className="mt-10">
              <div className="flex items-center mb-6">
                <div className="text-4xl font-bold text-black"><CountUp start={0} end={250} duration={6} delay={0.1} />+</div>
                <div className="ml-4">
                  <div className="text-xl font-bold text-black">Businesses Thrived</div>
                  <div className="text-gray-700">We helped more than 250 businesses to reach their business goals with our innovative solutions.</div>
                </div>
              </div>
              <hr className="border-gray-300 my-6" />
              <div className="flex items-center">
                <div className="text-4xl font-bold text-black"><CountUp start={0} end={100000000} duration={5} delay={1} />B+</div>
                <div className="ml-4">
                  <div className="text-xl font-bold text-black">Accumulated over $1B</div>
                  <div className="text-gray-700">Over the time, working from large to small businesses we have accumulated over $1B.</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center min-h-screen p-8">
          <div className="md:w-1/2">
            <h1 className="text-5xl font-bold">Values That</h1>
            <h2 className="text-4xl text-gray-500">Sets Us Apart</h2>
            <ul className="mt-8 space-y-4">
              <li className="text-xl">Transparent Communication</li>
              <li className="text-xl">Precision Management</li>
              <li className="text-xl">Meticulous Detail</li>
              <li className="text-xl">Innovative Excellence</li>
            </ul>
          </div>

          <div className="md:w-1/2 flex flex-col items-center mt-8 md:mt-0">
            <div className="relative">
              <img
                src="https://cdn.prod.website-files.com/643f7373d3f6653157617339/64f020a1ff0b6dea8f03dab6_best-communication.webp"
                alt="A woman smiling and holding a tablet"
                className="w-full h-auto"
              />
              <div className="absolute top-0 left-0 text-yellow-400 text-5xl font-bold" data-aos="fade-right">Transparent</div>
              <div className="absolute bottom-0 left-0 text-yellow-400 text-5xl font-bold" data-aos="fade-left">Communication</div>
            </div>
            <p className="mt-4 text-gray-400 text-center">
              We prioritize open dialogue, ensuring clients are informed at every turn. Our clear communication fosters trust and alignment, enriching collaboration.
            </p>
          </div>
        </div>
      </div>

      <div className="flex flex-col items-center">
        <div className="text-center mb-10">
          <h1 className="text-6xl font-extrabold text-black" data-aos="fade-right">How</h1>
          <h2 className="text-6xl font-extrabold text-gray-600" data-aos="fade-left">We Work</h2>
          <p className="mt-4 text-lg text-gray-700 max-w-2xl mx-auto">
            Our process is simple. We start with your needs, create engaging experiences, research, experiment with ideas, and use your feedback to guide us.
          </p>
        </div>

        <div className="flex flex-wrap justify-center mt-16 space-x-8">
          {[
            { icon: "fas fa-rocket", title: "Project kickoff" },
            { icon: "fas fa-search", title: "Discover" },
            { icon: "fas fa-pencil-alt", title: "Design" },
            { icon: "fas fa-cogs", title: "Implementation" },
          ].map((step, index) => (
            <div key={index} className="text-center mb-6">
              <div className="w-32 h-32 bg-white border border-gray-200 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-shadow duration-300">
                <i className={`${step.icon} text-4xl text-gray-600`}></i>
              </div>
              <p className="mt-4 text-lg font-semibold text-gray-800">{step.title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
